import { useEffect, useRef } from 'react';

const BOT = import.meta.env.VITE_TELEGRAM_BOT_USERNAME as string | undefined;

declare global {
  interface Window {
    onTelegramAuth?: (user: Record<string, unknown>) => void;
  }
}

/**
 * Official Telegram Login Widget (browser OAuth). Renders Telegram's own button
 * and forwards the signed user object to `onAuth`. Hidden when the bot username
 * isn't configured. (The bot's domain must be set in @BotFather to work.)
 */
export function TelegramLoginButton({
  onAuth,
}: {
  onAuth: (user: Record<string, unknown>) => void;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = ref.current;
    if (!BOT || !host) return;
    window.onTelegramAuth = (user) => onAuth(user);

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', BOT);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '14');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    host.appendChild(script);

    return () => {
      host.innerHTML = '';
    };
  }, [onAuth]);

  if (!BOT) return null;
  return <div ref={ref} className="tg-widget" />;
}
